<ng-container *ngIf="businessModel$ | async as businessModel">
  <div class="row price-row-spacing" *ngIf="businessModel === 'B2B'">
    <div class="col-8">
      <strong><ng-container *ngTemplateOutlet="subtotal"></ng-container></strong>
      <ng-template #subtotal>{{ 'checkout.pricing.priceOverview.subtotal' | transloco }}</ng-template>
    </div>
    <div class="col-4 pl-0 text-right">
      <ng-container *ngIf="pricingInformation !== null && pricingInformation !== 'LOADING'; else dash">
        <strong><ng-container *ngTemplateOutlet="netValue"></ng-container></strong>
        <ng-template #netValue>{{ pricingInformation.netValue | translocoCurrency: 'symbol':{}:pricingInformation.currency }}</ng-template>
      </ng-container>
    </div>
  </div>
  <div class="row price-row-spacing font-13" *ngIf="businessModel === 'B2B'">
    <div class="col-8">
      <span *ngIf="pricingInformation !== null && pricingInformation !== 'LOADING'; else vatB2B">
        <ng-container *ngIf="pricingInformation.vatReversed; else vatPercentageB2B">
          {{ 'checkout.pricing.priceOverview.vatReversed' | transloco }}
        </ng-container>
        <ng-template #vatPercentageB2B>
          <transloco
            id="6d17c728-d30f-41b0-a0f7-d2e40d8ed156"
            key="checkout.pricing.priceOverview.vatB2B"
            [params]="{
              vatPercentage: pricingInformation.vatPercentage | translocoPercent
            }">
          </transloco>
        </ng-template>
      </span>
      <ng-template #vatB2B>
        <span>{{ 'checkout.pricing.priceOverview.vatLoading' | transloco }}</span>
      </ng-template>
      <yat-tooltip-info-icon
        *ngIf="!hideTooltip"
        iconClass="ml-1"
        tooltipClass="tooltip-xl"
        [tooltipContent]="'checkout.pricing.priceOverview.vatTooltip' | transloco">
      </yat-tooltip-info-icon>
    </div>
    <div class="col-4 pl-0 text-right">
      <span *ngIf="pricingInformation !== null && pricingInformation !== 'LOADING'; else dash">
        {{ pricingInformation.vatValue | translocoCurrency: 'symbol':{}:pricingInformation.currency }}
      </span>
    </div>
  </div>
  <div class="row font-13">
    <div class="col-8">
      <strong *ngIf="businessModel === 'B2C'"><ng-container *ngTemplateOutlet="totalIncludingVatB2C"></ng-container></strong>
      <span *ngIf="businessModel === 'B2B'"><ng-container *ngTemplateOutlet="totalIncludingVatB2B"></ng-container></span>
      <ng-template #totalIncludingVatB2C>{{ 'checkout.pricing.priceOverview.totalIncludingVatB2C' | transloco }}</ng-template>
      <ng-template #totalIncludingVatB2B>{{ 'checkout.pricing.priceOverview.totalIncludingVatB2B' | transloco }}</ng-template>
    </div>
    <div class="col-4 pl-0 text-right">
      <ng-container *ngIf="pricingInformation !== null && pricingInformation !== 'LOADING'; else dash">
        <strong *ngIf="businessModel === 'B2C'"><ng-container *ngTemplateOutlet="totalB2C"></ng-container></strong>
        <span *ngIf="businessModel === 'B2B'"><ng-container *ngTemplateOutlet="totalB2B"></ng-container></span>
        <ng-template #totalB2C>{{ pricingInformation.total | translocoCurrency: 'symbol':{}:pricingInformation.currency }}</ng-template>
        <ng-template #totalB2B>{{ pricingInformation.total | translocoCurrency: 'symbol':{}:pricingInformation.currency }}</ng-template>
      </ng-container>
    </div>
  </div>
  <div class="row font-13" *ngIf="businessModel === 'B2C'">
    <div class="col-8">
      <span *ngIf="pricingInformation !== null && pricingInformation !== 'LOADING'; else vatB2C">
        <ng-container *ngIf="pricingInformation.vatReversed; else vatPercentageB2C">
          {{ 'checkout.pricing.priceOverview.vatReversed' | transloco }}
        </ng-container>
        <ng-template #vatPercentageB2C>
          <transloco
            id="589724ff-76c9-44bd-8412-0fedc9f3d9c6"
            key="checkout.pricing.priceOverview.vatB2C"
            [params]="{
              vatPercentage: pricingInformation.vatPercentage | translocoPercent
            }">
          </transloco>
        </ng-template>
      </span>
      <ng-template #vatB2C>
        <span>{{ 'checkout.pricing.priceOverview.vatLoading' | transloco }}</span>
      </ng-template>
      <yat-tooltip-info-icon
        *ngIf="!hideTooltip"
        iconClass="ml-1"
        tooltipClass="tooltip-xl"
        [tooltipContent]="'checkout.pricing.priceOverview.vatTooltip' | transloco">
      </yat-tooltip-info-icon>
    </div>
    <div class="col-4 pl-0 text-right">
      <span *ngIf="pricingInformation !== null && pricingInformation !== 'LOADING'; else dash">
        {{ pricingInformation.vatValue | translocoCurrency: 'symbol':{}:pricingInformation.currency }}
      </span>
    </div>
  </div>
  <ng-template #dash>
    <span>{{ 'checkout.pricing.priceOverview.dash' | transloco }}</span>
  </ng-template>
</ng-container>
